import React, { useEffect } from "react";
import Spinner from "./container/Spinner";
import Page from "./Page";
import { useGetQuery } from "./hooks/useGetQuery";
import { useKyc } from "./hooks/useKyc";

function App() {
  useEffect(() => {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/messenger.Extensions.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "Messenger");
  }, []);

  window.extAsyncInit = function () {
    console.log("Done loading");
  };

  const { parsedData } = useGetQuery();
  const { kyc, loading } = useKyc();

  return loading ? (
    <Spinner text="Loading..." />
  ) : (
    <Page parsedData={parsedData} initialState={kyc} />
  );
}

export default App;
